import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../services/service";
const BASE_URL = process.env.REACT_APP_ONBAORDING_URL;
type GetRefReponse = {
  data: any;
  message: string;
};

type GetRefRequest = {
  refId: string;
  routeName?: string;
  operation?: string;
};

export const emailRefApi = createApi({
  reducerPath: "emailRefApi",
  baseQuery: axiosBaseQuery({
    baseUrl: BASE_URL || "",
  }),
  tagTypes: ["emailRef"],
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getEmailRef: builder.mutation<GetRefReponse, GetRefRequest>({
      query: (data) => ({
        url: `getEmailRef`,
        method: "POST",
        requiredGuestAuth: true,
        body: {
            refId: data.refId,
            routeName: data?.routeName ?? "",
            operation: data?.operation ?? "",
        }
      }),
      invalidatesTags: ["emailRef"],
    })
  }),
});

export const { useGetEmailRefMutation } =
  emailRefApi;
